// @ts-nocheck
import React, { useState } from 'react'
import moment from 'moment'
import styled from 'styled-components'
import flow from '../../../assets/logs/Flow.svg'
import { Link } from 'react-router-dom'
import Network from '../../general/Network'
import { TasksDictionary } from '../../../constants/taskDictionary'
import LogsDetail from './LogDetails'
import { shortenAddress } from '../../../utils/web3-utils'
import LogPanel from './LogPanel'

const statusStyles = {
  notSimulated: {
    backgroundColor: 'rgba(239,64,111,0.06)',
    backgroundLabel: 'rgba(239,64,111,0.5)',
    color: '#ef406f',
  },
  simulationFailed: {
    backgroundColor: 'rgba(211,106,22,0.06)',
    backgroundLabel: 'rgba(211,106,22,0.4)',
    color: '#d36a16',
  },
  simulationReverted: {
    backgroundColor: 'rgba(128,0,128,0.06)',
    backgroundLabel: 'rgba(128,0,128,0.4)',
    color: '#c060c0',
  },
  simulationSucceeded: {
    backgroundColor: 'rgba(210,211,22,0.06)',
    backgroundLabel: 'rgba(210,211,22,0.35)',
    color: '#c8c920',
  },
  executionDelayed: {
    backgroundColor: 'rgba(22,127,211,0.06)',
    backgroundLabel: 'rgba(22,127,211,0.35)',
    color: '#167fd3',
  },
  executionSucceeded: {
    backgroundColor: 'rgba(51,194,176,0.05)',
    backgroundLabel: 'rgba(51,194,176,0.2)',
    color: '#33C2B0',
  },
  executionReverted: {
    backgroundColor: 'rgba(222,0,0,0.06)',
    backgroundLabel: 'rgba(222,0,0,0.3)',
    color: '#ff4444',
  },
  executionNotReached: {
    backgroundColor: 'rgba(197,127,66,0.06)',
    backgroundLabel: 'rgba(122,67,33,0.5)',
    color: '#c87f42',
  },
  transactionReverted: {
    backgroundColor: 'rgba(222,0,0,0.08)',
    backgroundLabel: 'rgba(222,0,0,0.4)',
    color: '#ff4444',
  },
}

const LogsItem = ({ item, width, colored, handleSelectPlanId, lite = false }) => {
  const [isOpen, setOpen] = useState(false)
  const icon = TasksDictionary[item?.task?.executionType]?.icon
  const showStatusColored = colored && item?.status?.type

  return (
    <>
      <Row status={showStatusColored}>
        <Td>
          <TimeText status={item?.status?.type}>
            {moment(item?.executedAt).fromNow()}
          </TimeText>
          <LogPanel open={isOpen} item={item} onClose={() => setOpen(!isOpen)} />
        </Td>
        <Td>
          <Network network={item?.chainId} noLogo={true} />
        </Td>
        <Td>
          <TaskFlex>
            <ActionIcon src={icon ? icon : flow} alt={item?.task?.executionType} />
            <TaskName>{item?.task?.name}</TaskName>
          </TaskFlex>
        </Td>
        <Td>
          <StatusBadge status={item?.status?.type}>{item?.status?.type}</StatusBadge>
        </Td>
        <DetailsTd>
          <LogsDetail item={item} />
        </DetailsTd>
        <Td>
          <PlanId>
            <PlanLink onClick={() => handleSelectPlanId(item?.planId)}>
              {shortenAddress(item?.planId)}
            </PlanLink>
            {` #${item?.index}`}
          </PlanId>
        </Td>
        <Td>
          <DetailsBtn onClick={() => setOpen(!isOpen)}>Details</DetailsBtn>
        </Td>
      </Row>
    </>
  )
}

const Row = styled.tr`
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  transition: background 0.1s;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.02);
  }
`

const Td = styled.td`
  padding: 10px 12px;
  vertical-align: middle;
  font-size: 13px;
  color: #a0a0a0;
  white-space: nowrap;
`

const DetailsTd = styled(Td)`
  white-space: normal;
  word-break: break-all;
  width: 100%;
  max-width: 0;
`

const TimeText = styled.span`
  color: ${({ status }) => statusStyles[status]?.color || '#555'};
  font-size: 12px;
  font-variant-numeric: tabular-nums;
`

const TaskFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 200px;
  overflow: hidden;
`

const ActionIcon = styled.img`
  height: 16px;
  width: 16px;
  object-fit: contain;
  flex-shrink: 0;
  opacity: 0.7;
`

const TaskName = styled.span`
  color: #ededed;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  background: ${({ status }) => statusStyles[status]?.backgroundLabel || 'rgba(255,255,255,0.06)'};
  color: ${({ status }) => statusStyles[status]?.color || '#a0a0a0'};
  white-space: nowrap;
`

const PlanId = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #777;
  font-size: 12px;
  font-family: 'SF Mono', 'Fira Code', monospace;
`

const PlanLink = styled.span`
  color: #777;
  cursor: pointer;
  &:hover {
    color: #a0a0a0;
    text-decoration: underline;
  }
`

export const DetailsBtn = styled.button`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 5px;
  color: #a0a0a0;
  font-size: 12px;
  padding: 4px 10px;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;

  &:hover {
    border-color: rgba(255, 255, 255, 0.15);
    color: #ededed;
  }
`

// Keep exported as Details for backward compat
export const Details = DetailsBtn

export default LogsItem
